export enum DeviceEnum {
  TABLET = "tablet",
  PC = "pc",
}
